import { render, staticRenderFns } from "./notification-template-seven-days-before.vue?vue&type=template&id=6bec0470&scoped=true"
import script from "./notification-template-seven-days-before.vue?vue&type=script&lang=js"
export * from "./notification-template-seven-days-before.vue?vue&type=script&lang=js"
import style0 from "./notification-template-seven-days-before.vue?vue&type=style&index=0&id=6bec0470&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bec0470",
  null
  
)

export default component.exports